<template>
	<div id="app">
		<Header></Header>
		<Content></Content>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from './components/header.vue'
	import Content from './content.vue'
	import Footer from './components/footer.vue'
	
	export default {
	  name: 'app',
	  components: {
	    Header,
	    Content,
		Footer,
	  }
	}
</script>

<style>
#app{
	min-width: 1200px;
}
	.index .top {
		position: relative;
	}
	
	.index .bg {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: -1;
	}
	
	.index .box {
		position: absolute;
		left: 30%;
		top: 45%;
		transform: translate(-50%,-50%);
	}
	
	.index .box h5 {
		font-size: 40px;
		color: #fff;
	}
	
	.index .box .el-button {
		color: #DA4831;
		font-weight: bold;
		margin: 30px 0;
	}
	
	.index .box p {
		color: #fff;
		font-size: 16px;
	}
</style>
